/**
 * @generated SignedSource<<bd71ae449aec1cd4e4976bfa83bed9bb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsHeroActions_viewer$data = {
  readonly allConversations: {
    readonly facets: {
      readonly buyerTags: {
        readonly activeHold: number | null;
        readonly activePrivateOffer: number | null;
        readonly unread: number | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "TradeBenefitsHeroActions_viewer";
};
export type TradeBenefitsHeroActions_viewer$key = {
  readonly " $data"?: TradeBenefitsHeroActions_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsHeroActions_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsHeroActions_viewer",
  "selections": [
    {
      "alias": "allConversations",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Literal",
          "name": "showInactiveUsers",
          "value": false
        }
      ],
      "concreteType": "ConversationsSolrConnection",
      "kind": "LinkedField",
      "name": "conversationsSolr",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConversationsFacetGroups",
          "kind": "LinkedField",
          "name": "facets",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ConversationsFacets",
              "kind": "LinkedField",
              "name": "buyerTags",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "unread",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "activePrivateOffer",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "activeHold",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "49e8d11ff1f86fc79145c39513462c34";

export default node;
